import 'latest-createjs';
import {TimelineLite} from 'gsap';
var AdobeAn;
var canvas, canvas_back, canvas_middle,
stage, stage_back, stage_middle,
anim_container, anim_container_back, anim_container_middle;

let exportRoot,
    exportRootBack,
    exportRootMiddle,
    prevExportRoot,
    prevExportRootBack,
    prevExportRootMiddle;

var state = {
  initialLoaded: false,
    progress: 0
};

var initialLoadPromises = [];
var backgroundLoadPromises = [];
var currentLoadPromises;
var animation;
var animations = new Array(12);





var svg_container, svg_line;

var comp, lib;
var initiated = false;
var numInitialLoad = 4;
var animRequested = null;
var requestedIndex = -1;
var curIndex = -1;
var timeout;
var tickerOn_b = false;
var tickerOn_m = false;
var resizeOn = false;
var currentAnimationStarted = false;
var currentActionDone = false;
var curMode = '';

function resetOldListerners() {
    var event = new Event('resetcanvas');
    window.dispatchEvent(event);
}

function stop() {
    if (stage && stage_back && stage_middle) {
        resetOldListerners();
        stage.removeAllChildren();
        stage.update();
        
        stage_back.removeAllChildren();
        stage_back.update();

        stage_middle.removeAllChildren();
        stage_middle.update();
    }
}

function play(index, delay, mode) {
    curMode = mode;

    if (!initiated) {

        return new Promise((resolve, reject) => {
            singleton.addEventListener('initiated', () => {
                resolve();
            });
        }).then(() => {
            return play(index);
        });
    }

    return new Promise((resolve, reject) => {

        if (typeof index === 'undefined') {resolve(); return;}

        animRequested = index;

        Promise.all(initialLoadPromises).then(() => {


            requestedIndex = index;
            if (!animations[index - 1] || !animations[index - 1].loaded)
            {
                currentLoadPromises = [];
                preload(index - 1, 1, currentLoadPromises);

                Promise.all(currentLoadPromises).then(() => {
                    curIndex = requestedIndex;
                    _instantiate(animations[index - 1]);
                    hidePrevious();
                    setTimeout(
                        function () {
                            resolve();
                            _play(delay - 0.1);
                        },
                        550
                    );

                });

                return;
            }

            curIndex = requestedIndex;
            _instantiate(animations[index - 1]);
            hidePrevious();
            setTimeout(
                function () {
                    resolve();
                    _play(delay - 0.1);
                },
                550
            );




        })
    });
}

function _instantiate(anim) {

    if (timeout) clearTimeout(timeout);
    _cancelAct();
    prevExportRoot = exportRoot;
    prevExportRootBack = exportRootBack;
    prevExportRootMiddle = exportRootMiddle;

    animation = anim;
    comp = animation.composition;
    AdobeAn = animation.AdobeAn;
    currentActionDone = false;
    currentAnimationStarted = false;


    let lib = comp.getLibrary();

    // var preloaderDiv = document.getElementById("_preload_div_");
    // preloaderDiv.style.display = 'none';
    // canvas.style.display = 'block';

    let c1 = lib['MonthAnimation_Front' + curMode];
    let c2 = lib['MonthAnimation_Back' + curMode];
    let c3 = lib['MonthAnimation_Middle' + curMode];

    exportRoot = (c1) ? new c1() : null;
    exportRootBack = (c2) ? new c2() : null;
    exportRootMiddle = (c3) ? new c3() : null;

    // console.log(lib);
    if (exportRootBack) {
        exportRootBack.setTransform(lib.properties.width / 2, lib.properties.height / 2);
        stage_back.addChild(exportRootBack);
    }

    if (exportRootMiddle) {
        exportRootMiddle.setTransform(lib.properties.width / 2, lib.properties.height / 2);
        stage_middle.addChild(exportRootMiddle);
    }

    if (exportRoot) {
        exportRoot.setTransform(lib.properties.width / 2, lib.properties.height / 2);
        stage_middle.addChild(exportRoot);
    }


    //Code to support hidpi screens and responsive scaling.
    function makeResponsive() {
        var lastDem_back = {lastW: 0, lastH: 0, lastS: 1, pRatio: 1};
        var lastDem_middle = {lastW: 0, lastH: 0, lastS: 1, pRatio: 1};
        if (!resizeOn) {
            window.addEventListener('resize', resizeCanvas);
            window.addEventListener('resetcanvas', resetCanvas);
            resizeOn = true;
        }

        function resetCanvas() {
            window.removeEventListener('resize', resizeCanvas);
            window.removeEventListener('resetcanvas', resetCanvas);
            resizeOn = false;
        }

        resizeCanvas();

        function resizeCanvas() {
            lastDem_back = resizeCanvas_inner(canvas_back, stage_back, anim_container_back, lastDem_back, true, false, 'height', true, 1);
            lastDem_middle = resizeCanvas_inner(canvas_middle, stage_middle, anim_container_middle, lastDem_middle, true, false, 'height', true, 1);
            resizeMCs();
            resizeSVG_inner();
        }

        function resizeMCs() {
            let yRatio;
            let xRatio;
            let r;

            switch (curMode)
            {
                case '_MT_P':
                    r = 0.8;
                    xRatio = (lastDem_middle.pRatio/stage_middle.scaleX)*((lastDem_middle.lastW > 528) ? 1 : (lastDem_middle.lastW / 528));
                    yRatio = (lastDem_middle.pRatio/stage_middle.scaleY)*((lastDem_middle.lastH > 938) ? 1 : (lastDem_middle.lastH / 938));
                    exportRoot.scaleX = exportRoot.scaleY = Math.min(xRatio, yRatio * r);
                    break;

                case '_M_L':
                    r = 0.8;
                    xRatio = (lastDem_middle.pRatio/stage_middle.scaleX)*((lastDem_middle.lastW > 1500) ? 1 : (lastDem_middle.lastW / 1500));
                    yRatio = (lastDem_middle.pRatio/stage_middle.scaleY)*((lastDem_middle.lastH > 938) ? 1 : (lastDem_middle.lastH / 938));
                    exportRoot.scaleX = exportRoot.scaleY = Math.min(xRatio, yRatio * r);
                    break;

                default:
                    xRatio = (lastDem_middle.pRatio/stage_middle.scaleX)*((lastDem_middle.lastW > 1500) ? 1 : (lastDem_middle.lastW / 1500));
                    yRatio = (lastDem_middle.pRatio/stage_middle.scaleY)*((lastDem_middle.lastH > 938) ? 1 : (lastDem_middle.lastH / 938));
                    exportRoot.scaleX = exportRoot.scaleY = Math.min(xRatio, yRatio);
                    break;
            }

        }

        function resizeCanvas_inner(canvas, stage, anim_container, lastDem, isResp, cut_Resp, respDim, isScale, scaleType, maxHeight, scale = 1) {
            var w = lib.properties.width, h = lib.properties.height;
            var iw = bodyWidth(), ih=(typeof maxHeight!== "undefined") ? Math.min(bodyHeight(), maxHeight) : bodyHeight();
            var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;
            if(isResp) {
                if((respDim==='width'&&lastDem.lastW===iw) || (respDim==='height'&&lastDem.lastH===ih)) {
                    sRatio = lastDem.lastS;
                }
                else if(!isScale) {
                    if(iw<w || ih<h)
                        sRatio = Math.min(xRatio, yRatio);
                }
                else if(scaleType===1) {
                    sRatio = (respDim==='width') ? xRatio : ((respDim==='height')) ? yRatio : Math.min(xRatio, yRatio);
                }
                else if(scaleType===2) {
                    sRatio = Math.max(xRatio, yRatio);
                }
            }
            if (cut_Resp) {
                canvas.width = w * pRatio * sRatio;
                canvas.height = h * pRatio * sRatio;
                canvas.style.width = w * sRatio + 'px';
                canvas.style.height = h * sRatio + 'px';
                stage.x = (w * pRatio * sRatio - w * pRatio * sRatio*scale) / 2;
                stage.y = (h * pRatio * sRatio - h * pRatio * sRatio*scale) / 2;
                anim_container.style.width =  Math.max(iw, w*sRatio)+'px';
                anim_container.style.height = Math.max(ih, h*sRatio)+'px';
            }
            else
            {
                canvas.width = iw * pRatio;
                canvas.height = ih * pRatio;
                canvas.style.width = iw + 'px';
                canvas.style.height = ih + 'px';
                stage.x = (iw * pRatio - w * pRatio * sRatio*scale) / 2;
                stage.y = (ih * pRatio - h * pRatio * sRatio*scale) / 2;
                anim_container.style.width =  iw+'px';
                anim_container.style.height = ih+'px';
            }
            stage.scaleX = pRatio*sRatio*scale;
            stage.scaleY = pRatio*sRatio*scale;
            stage.tickOnUpdate = false;
            stage.update();
            stage.tickOnUpdate = true;

            return {lastW: iw, lastH: ih, lastS: sRatio, pRatio: pRatio};
        }

        function resizeSVG_inner() {
            if (!svg_line || !svg_container)  return;

            var viewbox = svg_line.getAttribute('viewBox').split(' ');
            var svgWidth = parseInt(viewbox[2]);
            var svgHeight = parseInt(viewbox[3]);
            var iw = bodyWidth(), ih=bodyHeight();

            svg_line.style.width = ih * svgWidth / svgHeight + 'px';
            svg_line.style.height = svg_container.style.height = ih + 'px';


            if (iw / ih > svgWidth / svgHeight) {
                svg_line.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            } else {
                svg_line.setAttribute('preserveAspectRatio', 'xMidYMid slice');
            }
        }



        function bodyWidth() {
            let d = document,
                g = d.getElementsByTagName('body')[0];
            return g.offsetWidth;
        };

        function bodyHeight() {
            let d = document,
                g = d.getElementsByTagName('body')[0];
            return g.offsetHeight;
        };



    }

    if (exportRoot || exportRootBack || exportRootMiddle) {
        makeResponsive();
        AdobeAn.compositionLoaded(lib.properties.id);
    } else {
        console.log('All the MovieClips exportRoot, exportRootBack and exportRootMiddle can not be undefined');
    }
}

function _play(delay = 0.8) {
    delay = Math.max(delay, 0.1);
    let lib = comp.getLibrary();

    createjs.Ticker.setFPS(lib.properties.fps);
    if (!tickerOn_m) {
        if (exportRoot || exportRootMiddle) createjs.Ticker.addEventListener("tick", stage_middle);
        stage_middle.addEventListener('initialAnimationComplete', handle_initialAnimationComplete);
        stage_middle.addEventListener('action', handle_animationAction);
        window.addEventListener('resetcanvas', resetCanvas);
        tickerOn_m = true;
    }

    if (!tickerOn_b && exportRootBack) {
        createjs.Ticker.addEventListener("tick", stage_back);
        tickerOn_b = true;

    }

    function resetCanvas() {
        createjs.Ticker.removeEventListener("tick", stage_back);
        createjs.Ticker.removeEventListener("tick", stage_middle);
        stage_middle.removeEventListener('initialAnimationComplete', handle_initialAnimationComplete);
        stage_middle.removeEventListener('action', handle_animationAction);
        window.removeEventListener('resetcanvas', resetCanvas);
        tickerOn_m = false;
        tickerOn_b = false;
    }

    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
        if (exportRoot) exportRoot.play();
        if (exportRootBack) exportRootBack.play();
        if (exportRootMiddle) exportRootMiddle.play();
    }, delay * 1000);

}



function handleFileLoad(evt, animation) {
    let images = animation.composition.getImages();
    if (evt && evt.item.type === "image") { images[evt.item.id] = evt.result; }
}

function handleComplete(evt, animation) {
    animation.loaded = true;

    let AdobeAn = animation.AdobeAn;
    let comp = animation.composition;
    let lib = comp.getLibrary();

    //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
    AdobeAn.compositionLoaded(lib.properties.id);

    let ss = comp.getSpriteSheet();
    let queue = evt.target;
    let ssMetadata = lib.ssMetadata;

    if (queue) {
        for (let i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new createjs.SpriteSheet({ "images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames })
        }
    }

}

function loadAnimationResources(animation, complete, ratio) {
    animation.loading = true;
    let lib = animation.composition.getLibrary();
    let lastProgress = 0;
    let loader = new createjs.LoadQueue(false);
    loader.addEventListener("fileload", function (evt) { handleFileLoad(evt, animation); setProgress(state.progress + ratio * (loader.progress - lastProgress)); lastProgress = loader.progress; });
    loader.addEventListener("complete", function (evt) { handleComplete(evt, animation); if (typeof complete === 'function') complete.call(this, animation); });
    loader.loadManifest(lib.properties.manifest);
}

function preload(start, num, promisesStack) {
    let a;
    for (let i = start; i < Math.min(start + num, animations.length); i++)
    {
        if (!animations[i]) {
            promisesStack.push(
                new Promise((resolve, reject) => {
                    let p;
                    switch (i)
                    {
                        case 0:
                            p = import('./animation/animation-1.js');
                            break;
                        case 1:
                            p = import('./animation/animation-2.js');
                            break;
                        case 2:
                            p = import('./animation/animation-3.js');
                            break;
                        case 3:
                            p = import('./animation/animation-4.js');
                            break;
                        case 4:
                            p = import('./animation/animation-5.js');
                            break;
                        case 5:
                            p = import('./animation/animation-6.js');
                            break;
                        case 6:
                            p = import('./animation/animation-7.js');
                            break;
                        case 7:
                            p = import('./animation/animation-8.js');
                            break;
                        case 8:
                            p = import('./animation/animation-9.js');
                            break;
                        case 9:
                            p = import('./animation/animation-10.js');
                            break;
                        case 10:
                            p = import('./animation/animation-11.js');
                            break;
                        case 11:
                            p = import('./animation/animation-12.js');
                            break;
                    }

                    if (p)
                         p.then(anim => {
                             animations[i] = anim;
                             //console.log("JS LOADED", anim);
                             setProgress(state.progress + 0.1 / num);
                             resolve(anim);
                        })
                    else
                        resolve(null);
                })
                    .then(anim => {
                        return new Promise((resolve, reject) => {
                            if (anim && !anim.loaded)
                                loadAnimationResources(anim, resolve, 0.9 / num);
                            else
                            {
                                setProgress(state.progress + 0.9 / num);
                                resolve();
                            }
                        })
                    })
            );

        }
        else  if (!animations[i].loaded) {
            a = animations[i];
            promisesStack.push(
                new Promise((resolve, reject) => {
                    if (a && !a.loaded)
                        loadAnimationResources(a, resolve, 1 / num);
                    else
                    {
                        setProgress(state.progress + 1 / num);
                        resolve();
                    }
                })
            );
        }
    }

}

function hidePrevious() {

    let tl = new TimelineLite({});

    if (prevExportRoot)
    {
        _hide_(prevExportRoot, 0.15, tl);
        prevExportRoot = null;
    }
    if (prevExportRootBack)
    {
        _hide_(prevExportRootBack, 0, tl);
        prevExportRootBack = null;
    }
    if (prevExportRootMiddle)
    {
        _hide_(prevExportRootMiddle,0, tl);
        prevExportRootMiddle = null;
    }

    function _hide_(elem, delay, tl, callback) {
        tl.to(elem, 0.4, {
            alpha: 0,
            onComplete: (elem1) => {
                if (elem1.parent) elem1.parent.removeChild(elem1);
            },
            onCompleteParams: [
                elem
            ]
        }, "st+="+delay);
    }
}


function init() {
    createjs.MotionGuidePlugin.install();

    setTimeout(() => {

        canvas_back = document.getElementById("canvas-back");
        anim_container_back = document.getElementById("canvas-animation-back");

        canvas_middle = document.getElementById("canvas-middle");
        anim_container_middle = document.getElementById("canvas-animation-middle");
    
        svg_container = document.getElementById("svg-animation");
        svg_line = svg_container.querySelector('svg');

        stage_back = new createjs.Stage(canvas_back);
        stage_middle = new createjs.Stage(canvas_middle);

        canvas_back.stage = stage_back;
        canvas_middle.stage = stage_middle;

        initiated = true;

        singleton.dispatchEvent('initiated');

    }, 100);
}


function act() {
    stage_back.dispatchEvent('makeActionRequest');
    stage_middle.dispatchEvent('makeActionRequest');
}


function _cancelAct() {
    stage_back.dispatchEvent('cancelActionRequest');
    stage_middle.dispatchEvent('cancelActionRequest');
}

function handle_initialAnimationComplete() {
    if (currentAnimationStarted) return;
    currentAnimationStarted = true;

    const evt = new createjs.Event('done');
    evt.currentAnimationIndex = curIndex;
    singleton.dispatchEvent(evt);
}


function handle_animationAction(evt0) {
    const evt = new createjs.Event('action');
    evt.currentAnimationIndex = curIndex;
    singleton.dispatchEvent(evt);
}



function setProgress(p) {
    if (state.initialLoaded) return;
    state.progress = p;
    let evt = new createjs.Event('initialLoadProgress');
    evt.progress = p;
    singleton.dispatchEvent(evt);
}


const singleton = {
    play: play,
    stop: stop,
    act: act,
    state: state,
    all: {
        stage_back, canvas_back, anim_container_back
    }
}
createjs.EventDispatcher.initialize(singleton);

init();
preload(0, numInitialLoad, initialLoadPromises);

// BACKGROUND PRELOADING:
Promise.all(initialLoadPromises).then(() => {
    state.initialLoaded = true;
    singleton.dispatchEvent('initialLoadComplete');
    preload(numInitialLoad, 12 - numInitialLoad, backgroundLoadPromises);
});


module.exports = singleton;


// WEBPACK FOOTER //
// ./js/bg-canvas.js